document.addEventListener("alpine:init", () => {
  const appContentSelectors =
    ATAR_JOURNEY_DATA.atarCalculator.appContentSelectors;

  const _getAppContent = (selector) => {
    const elem = document.querySelector(selector);
    return elem ? elem.innerHTML : "";
  };

  Alpine.data("subjects", function () {
    return {
      fields: [1, 2, 3, 4],

      atarScore: 0,

      // atarJourney_selectedSubjects: (() => this['$custom-persist']([]).as('test1'))(),
      // atarJourney_subjectRawScores: (() => this['$custom-persist']([]).as('test2'))(),

      selectedSubjects: this.$customPersist([]).as(
        "atarJourney_selectedSubjects"
      ),
      subjectRawScores: this.$customPersist([]).as(
        "atarJourney_subjectRawScores"
      ),
      // atarJourney_selectedSubjects: this.$persist([]),
      // atarJourney_subjectRawScores: this.$persist([]),

      aggregateToATARMap: ATAR_JOURNEY_DATA.aggregateToATARMap,

      subjectData: ATAR_JOURNEY_DATA.subjectData,

      // showAdjustmentPoints: false,

      appContent: {
        adjustmentPointsFootnoteHTML: _getAppContent(
          appContentSelectors.adjustmentPointsFootnote
        ),
      },

      initialised: false,

      init() {
        const numInputGroup = Math.max(
          this.selectedSubjects.length,
          this.selectedSubjects.length
        );

        for (let i = 4; i < numInputGroup; i++) {
          this.addSubject();
        }

        this.$nextTick(() => {
          for (let i = 0; i < numInputGroup; i++) {
            const inputIndex = i + 1;
            const _subject = this.selectedSubjects[i];
            const _rawScore = this.subjectRawScores[i];

            _rawScore &&
              (document.querySelector("#subject-raw-" + inputIndex).value =
                _rawScore);
            _subject &&
              (document.querySelector("#subject-dropdown-" + inputIndex).value =
                _subject);
          }

          this.$nextTick(() => {
            // recalculate scaled value of all input groups, but NOT setting store's value
            for (let j = 0; j < numInputGroup; j++) {
              try {
                const inputIndex = j + 1;
                const _subject = this.selectedSubjects[j];
                const _rawScore = this.subjectRawScores[j];
                if (_rawScore && _subject) {
                  this.calculateScaledScore(_rawScore, inputIndex);
                }
              } catch (error) {}
            }

            this.atarScore = Alpine.store("atarCalculator").adjustedATAR;

            if (!!Alpine.store("atarCalculator").adjustmentPoints) {
              // this.showAdjustmentPoints = true;
            }
            this.adjustATAR();

            this.initialised = true;
          });
        });
      },

      subjectList: function () {
        return this.subjectData.map((subject) => subject.name).sort();
      },

      englishSubjects: function () {
        let literature = this.subjectData
          .map((subject) => subject.name)
          .filter((subject) => subject == "Literature");
        let english = this.subjectData
          .map((subject) => subject.name)
          .sort()
          .filter((subject) => subject.includes("English"));
        return english.concat(literature).sort();
      },

      filterSubjects: function () {
        var list = this.subjectList();
        return list.filter((text) => this.subjectList.includes(text));
      },

      addedSubjects: [],

      calculateScaledScore(rawScore, field) {
        // If field is 5 or 6, calculate as increment
        var activeRow = "scaledScore" + field;
        var scaledScore = 0;
        var selectedSubject = document.querySelector(
          "#subject-dropdown-" + field
        ).value;

        if (selectedSubject) {
          scaledScore = this.getScaledScore(
            rawScore,
            this.getScaledScoreForSubject(selectedSubject).scaling
          );
          // console.log(rawScore, scaledScore);
          document.querySelector("#subject-scaled-" + field).value = Math.round(
            scaledScore || 0
          );
          document.querySelector(
            "#subject-scaled-" + field
          ).dataset.scaledScore = scaledScore;
        }

        if (this.initialised) {
          // recalculate ATAR
          this.calculateATAR();
        } else {
          // trigger to show ATAR slider during initialisation
          this.fourSubjectsSelected();
        }

        this._storeRawScores();

        return false;
      },

      _storeRawScores() {
        var listOfRawScores = document.querySelectorAll(
          "input[id*=subject-raw]"
        );
        var listOfRawScoresArray = Array.prototype.slice.call(listOfRawScores);
        this.subjectRawScores = listOfRawScoresArray.map((elem) => elem.value);
      },

      getScaledScoreForSubject: function (selectedSubject) {
        return this.subjectData.find(
          (subject) => subject.name === selectedSubject
        );
      },

      getScaledScore(userScore, scoreRanges) {
        let scaled = userScore;
        // console.log('inside getScaledScore', userScore, scoreRanges)
        for (let i = 0; i < scoreRanges.length; i++) {
          let _newScaledScore;

          const _currentRange = scoreRanges[i];
          const _nextRange = scoreRanges[i + 1];

          if (i == 0 && userScore < _currentRange.raw) {
            // lower than first range
            _newScaledScore = (
              (userScore / _currentRange.raw) *
              _currentRange.scaled
            ).toFixed(2);
          } else if (
            i === scoreRanges.length - 1 &&
            userScore > _currentRange.raw
          ) {
            // higher than last range, return scaled score
            _newScaledScore = Math.round(_currentRange.scaled);
          } else if (
            _nextRange &&
            userScore >= _currentRange.raw &&
            userScore <= _nextRange.raw
          ) {
            // within a range, calculate the scaled score
            _newScaledScore =
              ((userScore - _currentRange.raw) /
                (_nextRange.raw - _currentRange.raw)) *
                (_nextRange.scaled - _currentRange.scaled) +
              _currentRange.scaled;
          }

          if (_newScaledScore) {
            scaled = _newScaledScore;
            break;
          }
        }

        return scaled;
      },

      // selectedSubjectList: function() {
      //     // FIX: if one field has it and exists, then show error
      //     if (this.selectedSubjects.includes(this.$el.value)) {
      //         alert("You've already chosen that, try another subject.");
      //         return false;
      //     }

      //     this.selectedSubjects.push(this.$el.value);
      //     console.log('list', this.selectedSubjects);
      // },

      selectedSubjectList: function () {
        var listOfSubjects = document.querySelectorAll(
          "select[id*=subject-dropdown]"
        );
        var listOfSubjectsArray = Array.prototype.slice.call(listOfSubjects);

        if (
          this.selectedSubjects.includes(this.$el.value) &&
          this.$el.value !== ""
        ) {
          alert(
            "You've already chosen " + this.$el.value + ". Try another subject."
          );
          this.$el.value = "";
          this.selectedSubjects = listOfSubjectsArray.map(
            (subject) => subject.value
          );
          return false;
        }

        this.selectedSubjects = listOfSubjectsArray.map(
          (subject) => subject.value
        );
      },

      fourSubjectsSelected: function () {
        var englishSubjectSelected =
          document.querySelector("#subject-dropdown-1").value !== "";
        var secondSubjectSelected =
          document.querySelector("#subject-dropdown-2").value !== "";
        var thirdSubjectSelected =
          document.querySelector("#subject-dropdown-3").value !== "";
        var fourthSubjectSelected =
          document.querySelector("#subject-dropdown-4").value !== "";

        // console.log('pass', englishSubjectSelected, secondSubjectSelected, thirdSubjectSelected, fourthSubjectSelected);

        if (this.initialised) {
          Alpine.store("atarCalculator").fourSubjectsSelected =
            englishSubjectSelected &&
            secondSubjectSelected &&
            thirdSubjectSelected &&
            fourthSubjectSelected;
        }

        return (
          englishSubjectSelected &&
          secondSubjectSelected &&
          thirdSubjectSelected &&
          fourthSubjectSelected
        );
      },

      addSubject: function () {
        if (this.fields.length >= 6) {
          return false;
        }

        //this.fields.push(this.fields.length + 2);
        this.fields.push(this.fields[this.fields.length - 1] + 1);
        // console.log('fields add', this.fields.slice(0))
      },

      removeSubject: function (field, index) {
        if (index <= 3) {
          //  if (this.fields.length === 4) {
          document.querySelector("#subject-raw-" + field).value = "";
          document.querySelector("#subject-scaled-" + field).value = "";
          delete document.querySelector("#subject-scaled-" + field).dataset
            .scaledScore;
          this.calculateATAR();
          return false;
        }

        /* For the fifth and sixth subjects */
        if (document.querySelector("#subject-raw-" + field).value !== "") {
          document.querySelector("#subject-raw-" + field).value = "";
          document.querySelector("#subject-scaled-" + field).value = "";
          delete document.querySelector("#subject-scaled-" + field).dataset
            .scaledScore;
          this.calculateATAR();
          return false;
        }

        this.fields.splice(index, 1);
        this.calculateATAR();
        console.log("fields", this.fields);
      },

      calculateATAR: function () {
        this.fourSubjectsSelected();
        var total = 0;
        var currentScore = 0;
        var englishSubjectScore;
        var scaledScoreStructure = [];
        var scaledScoreStructureWithoutFirstSubject = [];

        var scaledValues = document.querySelectorAll('[id^="subject-scaled-"]');
        // console.log(scaledValues);

        scaledValues.forEach((scaledScore, index) => {
          scaledScoreStructure.push({
            id: index,
            score: scaledScore.dataset.scaledScore,
          });
        });

        englishSubjectScore = parseFloat(scaledScoreStructure[0].score);

        scaledScoreStructureWithoutFirstSubject = scaledScoreStructure
          .slice(1)
          .sort(function (a, b) {
            return b.score - a.score;
          });
        // console.log("sorted?", scaledScoreStructureWithoutFirstSubject, scaledScoreStructure);

        scaledScoreStructureWithoutFirstSubject.forEach(
          (scaledScore, index) => {
            // console.log('val', scaledScore.score, 'i:', index);

            if (index <= 2) {
              // Increment
              currentScore = parseFloat(scaledScore.score) || 0;
            } else {
              // console.log('5th or 6th best score' + scaledScore.score);
              // VCE subject scores  as increments
              currentScore = parseFloat(scaledScore.score / 10) || 0;
            }

            // console.log("curr", currentScore);

            total += currentScore;
          }
        );
        // console.log("total 1", total);
        total += englishSubjectScore;
        // console.log("total 2", total);

        // console.log('total', total);
        this.atarScore = (
          this.aggregateToATARMap
            .slice()
            .reverse()
            .find((atar) => {
              // console.log(atar.lowerBound, total >= atar.lowerBound >= total);
              return total >= atar.lowerBound;
            }) || {
            ATAR: this.aggregateToATARMap[0].ATAR - 0.05,
          }
        ).ATAR;

        Alpine.store("atarCalculator").adjustedATAR = this.atarScore;
        this.adjustATAR();
      },

      adjustATAR() {
        const atarValue = Alpine.store("atarCalculator").adjustedATAR;
        const adjustmentPoints = isNaN(
          Alpine.store("atarCalculator").adjustmentPoints
        )
          ? 0
          : parseInt(Alpine.store("atarCalculator").adjustmentPoints, 10);

        if (adjustmentPoints) {
          (async () => {
            const rawResponse = await fetch(
              "/atar/wizard/api/calculator/calculate-adjusted",
              {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  atar: atarValue,
                  adjustmentPoints: adjustmentPoints,
                }),
              }
            );
            const data = await rawResponse.json();

            Alpine.store("atarCalculator").estimateAdjustedATAR = parseFloat(
              data.adjustedATAR
            );
            Alpine.store("atarCalculator").adjustmentPoints =
              data.adjustmentPoints;
          })();
        } else {
          Alpine.store("atarCalculator").estimateAdjustedATAR = atarValue;
        }
      },
    };
  });
});
